import { render, staticRenderFns } from "./SelectClient.vue?vue&type=template&id=4064e00f&"
import script from "./SelectClient.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SelectClient.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports